import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';

export default class MetadataValueLabel extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    // @ts-ignore
    const { styles } = MetadataValueLabel;

    return (
      <div className={css(styles.label)}>
        {this.props.children}
      </div>
    );
  }
}

// @ts-ignore
const styles = cssInJS({
  label: {
    paddingTop: 10,
    paddingLeft: 5,
    marginBottom: 10,
    // @ts-ignore
    fontSize: THEME.editFontSize,

    '@phone': {
      display: 'block',
      width: '100%',
      paddingLeft: 0,
    },
  },
});
// @ts-ignore
MetadataValueLabel.styles = styles;
